import { render, staticRenderFns } from "./MealsPage.vue?vue&type=template&id=0b759e8e&scoped=true"
import script from "./MealsPage.vue?vue&type=script&lang=js"
export * from "./MealsPage.vue?vue&type=script&lang=js"
import style0 from "./MealsPage.vue?vue&type=style&index=0&id=0b759e8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b759e8e",
  null
  
)

export default component.exports